import { dynamic } from 'src/utils/ssr'

/**
 * Client-only bootstrap component. Holds browser preludes and side effects
 * that were previously at module-level in pages/Root.tsx.
 *
 * Uses outer/inner file split to guarantee this file is server-import-safe:
 * all browser dependencies live exclusively in ClientBootInner.tsx.
 */
export const ClientBoot = dynamic(() => import('./ClientBootInner'), {
  ssr: false,
})
